<template>
  <b-card v-if="data" no-body class="mb-0">
    <div v-if="!series[0]" >
      <b-skeleton
        class="mx-auto"
        type="avatar"
        width="200px"
        height="200px"
      ></b-skeleton>
    </div>
    <!-- apex chart -->
    <vue-apex-charts
      v-else
      type="radialBar"
      height="250"
      class="my-2"
      :options="goalOverviewRadialBar"
      :series="data.series"
    />
    <!-- <b-row class="text-center mx-0">
      <b-col
        cols="6"
        class="d-flex align-items-center flex-column "
      >
        <b-card-text class="text-muted mb-50"> تعداد کل جلسات </b-card-text>
        <b-skeleton v-if="!completed" width="60px"></b-skeleton>
        <h3 v-else class="font-weight-bolder mb-0">
          {{ data.completed }}
        </h3>
      </b-col>

      <b-col
        cols="6"
        class=" d-flex align-items-center flex-column  "
      >
        <b-card-text class="text-muted mb-50">جلسات دیده شده </b-card-text>
        <b-skeleton v-if="!inProgress === null" width="60px"></b-skeleton>
        <h3 v-else class="font-weight-bolder mb-0">
          {{ data.inProgress }}
        </h3>
      </b-col>
    </b-row> -->
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BRow,
  BCol,
  BCardText,
  BSkeleton,
} from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";
import { $themeColors } from "@themeConfig";

const $strokeColor = "#ebe9f1";
const $textHeadingColor = "#5e5873";
const $goalStrokeColor2 = "#51e5a8";
export default {
  components: {
    VueApexCharts,
    BCard,
    BCardHeader,
    BRow,
    BCardText,
    BCol,
    BSkeleton,
  },
  props: {
    progress: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
      data: {
        completed: null,
        inProgress: null,
        series: [],
      },
      goalOverviewRadialBar: {
        chart: {
          height: 245,
          type: "radialBar",
          sparkline: {
            enabled: true,
          },
          dropShadow: {
            enabled: true,
            blur: 3,
            left: 1,
            top: 1,
            opacity: 0.1,
          },
        },
        colors: [$goalStrokeColor2],
        plotOptions: {
          radialBar: {
            offsetY: -10,
            startAngle: -150,
            endAngle: 150,
            hollow: {
              size: "77%",
            },
            track: {
              background: $strokeColor,
              strokeWidth: "50%",
            },
            dataLabels: {
              name: {
                show: false,
              },
              value: {
                color: $textHeadingColor,
                fontSize: "2.86rem",
                fontWeight: "600",
              },
            },
          },
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "dark",
            type: "horizontal",
            shadeIntensity: 0.5,
            gradientToColors: [$themeColors.success],
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100],
          },
        },
        stroke: {
          lineCap: "round",
        },
        grid: {
          padding: {
            bottom: 30,
          },
        },
      },
    };
  },

  computed: {
    completed() {
      return (this.data.completed = this.progress.all);
    },
    inProgress() {
      return (this.data.inProgress = this.progress.count_seen);
    },
    series() {
      return (this.data.series[0] = this.progress.progress);
    },
  },
};
</script>
